

































import Field from "@/components/basic/fields/Field.vue";
import Vue from "vue";
import { FieldInterface, TaxResidenceDataResponseInterface } from "@/types";
import { mapState } from "vuex";

export default Vue.extend({
  name: "TaxOfficeListField",
  props: {
    isOpen: Boolean,
    name: String,
    taxOfficeDataForeigner: Object,
    passedData: Object,
    taxResidence: String,
  },
  data() {
    return {
      taxOffices: this.$store.state.config.taxOffices,
      filteredTaxOffices: this.$store.state.config.taxOffices,
      formData: {
        key: "",
        value: "",
      } as FieldInterface,
      TRANSLATION_KEY: "compositeFields.TaxOfficeListField",
    };
  },
  mounted() {
    this.returnService();
    this.setDefaultTaxOfficeForForeigner();
  },
  methods: {
    returnService(): void {
      if (this.passedData) {
        for (const entry in this.passedData) {
          if (this.formData.hasOwnProperty(entry)) {
            (this as any).formData[entry] = this.passedData[entry];
          }
        }
      }
    },
    close(): void {
      this.$emit("close");
    },
    setDefaultTaxOfficeForForeigner(): void {
      const defaultForeignerTaxOffice = [String(this.taxOfficeDataForeigner.key), this.taxOfficeDataForeigner.value];
      if (Object.keys(this.taxOfficeDataForeigner).length) {
        this.taxOffices = [
          defaultForeignerTaxOffice,
          ...this.taxOffices.filter( (item:any) => {return item[0] != defaultForeignerTaxOffice[0]}),
        ];
        this.setValue(this.taxOfficeDataForeigner.key, this.taxOfficeDataForeigner.value);
      }
    },
    setValue(id: string, text: string): void {
      this.formData.value = text;
      this.formData.key = id;

      this.$emit("input", this.formData);
    },

    search(): void {
      if (!this.taxOffices.length) {
        this.taxOffices = this.$store.state.config.taxOffices;
      }
      this.filteredTaxOffices = this.taxOffices.filter((entry: any) => {
        return entry[1].toLowerCase().indexOf(this.formData.value.trim().toLowerCase()) > -1;
      });
    },
    clearFormData() {
      this.formData.key = ""
      this.formData.value = ""
    }
  },
  watch: {
    isOpen(): void {
      this.clearFormData();
      this.search();
    },
    "formData.value"(): void {
      this.search();
    },
    taxOfficeDataForeigner(): void {
      this.setDefaultTaxOfficeForForeigner();
    },
  },
  computed: {
    ...mapState({
      taxResidenceData: (state: any): TaxResidenceDataResponseInterface => state.formData,
    }),
  },
  components: {
    Field,
  },
});
